import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from "axios";
import router from 'vue-router'

Vue.use(Vuex)

const Auth = {
  namespaced: true,
  state: {
    tokens: {
      access_token: null,
      expires_in: null,
      refresh_token: null,
      token_type: null,
    },
    currentUser: {
      name: null,
      email: null,
    },
    currentUserData: {
      id: null,
      img: null,
      name: null,
      patronymic: null,
      surname: null
    }
  },
  actions: {
    login: (context, user) => {
      return new Promise((resolve, reject) => {
        let data = {
          client_id: 1,
          client_secret: 'Fj8jLxWZXnw86a0eAejwAFlWPorSwZJsNEEf0b6O',
          grant_type: 'password',
          username: user.email,
          password: user.password,
        };
        axios.post(API.login, data)
          .then(response => {
            let responseData = response.data
            let now = Date.now()
            responseData.expires_in = responseData.expires_in + now
            context.commit('updateTokens', responseData)
            axios.defaults.headers.common['Authorization'] = `Bearer ${responseData.access_token}`;
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    loginVrachiRf: (context, code) => {
      return new Promise((resolve, reject) => {
        let data = {
          code: code
        };
        axios.post(API.loginVrachiRf, data)
          .then(response => {
            let responseData = response.data
            let now = Date.now()
            responseData.expires_in = responseData.expires_in + now
            context.commit('updateTokens', responseData)
            axios.defaults.headers.common['Authorization'] = `Bearer ${responseData.access_token}`;
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getCurrentUser: (context) => {
      return new Promise((resolve, reject) => {
        axios.get(API.user)
          .then(response => {
            let responseData = response.data
            context.commit('updateCurrentUser', responseData)
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getCurrentUserData: (context) => {
      return new Promise((resolve, reject) => {
        axios.get(API.userData)
          .then(response => {
            let responseData = response.data
            context.commit('updateCurrentUserData', responseData)
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getParameters: (context, params) => {
      let type = '';
      if(params) {
        type = '?data_type=' + params.type
      }
      return new Promise((resolve, reject) => {
        axios.get(API.parameters + type)
          .then(response => {
            let responseData = response.data
            context.commit('updateCurrentUser', responseData)
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getSettings: (context) => {
      return new Promise((resolve, reject) => {
        axios.get(API.settings)
          .then(response => {
            let responseData = response.data
            //context.commit('updateCurrentUser', responseData)
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    logout: (context, dispatch) => {
      return new Promise((resolve, reject) => {
        axios.get(API.logout)
          .then(response => {
            let token = {
              access_token: null,
              expires_in: null,
              refresh_token: null,
              token_type: null,
            }
            let currentUser = null
            let currentUserData = {
              id: null,
              img: null,
              name: null,
              patronymic: null,
              surname: null
            }
            context.commit('updateTokens', token)
            context.commit('updateCurrentUser', currentUser)
            context.commit('updateCurrentUserData', currentUserData)
            delete axios.defaults.headers.common['Authorization']
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    }
  },

  mutations: {
    updateTokens: (state, tokens) => {
      state.tokens = tokens
    },
    updateCurrentUser: (state, currentUser) => {
      state.currentUser = currentUser
    },
    updateCurrentUserData: (state, currentUserData) => {
      state.currentUserData = currentUserData
    }
  },
  getters: {
    getAccessToken: state => {
      return state.tokens.access_token
    },
    getCurrentUser: state => {
      return state.currentUser
    },
    getCurrentUserData: state => {
      return state.currentUserData
    }
  }
};

const Layout = {
  namespaced: true,
  state: {
    mobileMenu: false
  },
  getters: {
    getMobileMenu: state => {
      return state.mobileMenu
    },
  },
  actions: {
    updateMobileMenu: (context, status) => {
      context.commit('updateMobileMenu', status)
    }
  },
  mutations: {
    updateMobileMenu: (state, status) => {
      state.mobileMenu = status
    },
  }
};

const Patients = {
  namespaced: true,
  state: {
    patientId: null,
    pharmPassportData: null,
    recommendationsData: null,
  },
  actions: {
    getPatients: (context, params) => {
      let my = '';
      if (params.my == true) {
        my = '?my=true'
      }
      return new Promise((resolve, reject) => {
        axios.get(API.patients + my)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    filterPatients: (context, params) => {
      return new Promise((resolve, reject) => {
        axios.post(API.patients + 'filters',{ my: params.my, only_today: params.only_today })
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getPatientConsultationsById: (context, params) => {
      console.log(params.patientId)
      console.log(API.patients + params.patientId + '/appointments')
      let my = '';
      if (params.my == true) {
        my = '?my=true'
      }
      return new Promise((resolve, reject) => {
        axios.get(API.patients + params.patientId + '/appointments' + my)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getPatientVisitsById: (context, params) => {
      console.log(params.patientId)
      console.log(params.my)
      let my = '';
      if (params.my == true) {
        my = '?my=true'
      }
      console.log(API.patients + params.patientId + '/consultations' + my)
      return new Promise((resolve, reject) => {
        axios.get(API.patients + params.patientId + '/consultations' + my)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getPatientDataById: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.get(API.patients + params.patientId + '/patientdata?data_type=' + params.data_type)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    updatePatientDataById: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.post(API.patients + params.patientId + '/patientdata', { parameters: params.parameters })
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    updatePatientId: (context, patientId) => {
      if (patientId) {
        context.commit('updatePatientId', patientId)
      }
    },
    getPatientForm: () => {
      return new Promise((resolve, reject) => {
        axios.post(API.patients)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    addPatient: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.post(API.patients, params)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getVisitInfoById: (context, params) => {
      return new Promise((resolve, reject) => {
        axios.get(API.consultations + '/protocol/' + params.consId)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getConsultaionForm: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.post(API.appointments, { patient_id: params.patientId, consultation_id: params.consultationId, medspecialite_id: params.medspecialiteId, medorganisation_id: params.medorganisationId, doctor_id: params.doctorId, protocol_id: params.protocolId })
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    createConsultation: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.post(API.appointments, params)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    completeConsultation: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.post(API.consultations + '/close', params)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    cancelConsultation: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.post(API.consultations + '/changestatus', params)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    deleteConsultation: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.delete(API.appointments + '/' + params.protocol_id)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    }
  },
  mutations: {
    updatePatientId: (state, patientId) => {
      state.patientId = patientId
    }
  },
  getters: {
    getPatientId: (state) => {
      return state.patientId
    }
  }
};

const Consultations = {
  namespaced: true,
  state: {
    consId: null,
    pharmPassportData: null,
    recommendationsData: null,
    resultsData: null
  },
  actions: {
    getConsultations: (context, params) => {
      let date = ''
      if (params) {
        date = '?selectdate=' + params.consultDate
      }
      return new Promise((resolve, reject) => {
        axios.get(API.consultations + date)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getConsultationsById: (context, params) => {
      return new Promise((resolve, reject) => {
        axios.get(API.consultations + '/' + params.consId)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getTreeVC: () => {
      return new Promise((resolve, reject) => {
        axios.get(API.treeVc)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getWord: (context, params) => {
      return new Promise((resolve, reject) => {
        axios.get('/api/sppvr/' + params.ajax + '?word=' + params.query)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    getImportList: (context, params) => {
      return new Promise((resolve, reject) => {
        axios.get('/api/sppvr/' + params.ajax + '/' + params.subpartId + '/' + params.protocolId)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    deleteConsultationsById: (context, params) => {
      return new Promise((resolve, reject) => {
        axios.get(API.deleteConsultations + params.consId)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    drugChoice5step: (context, params) => {
      console.log(params)
      return new Promise((resolve, reject) => {
        axios.post(API.drugchoice, params)
          .then(response => {
            resolve(response)
          })
          .catch(response => {
            reject(response)
          })
      })
    },
    updateConsId: (context, consId) => {
      if (consId) {
        if (consId == 'clear') {
          context.commit('updateConsId', '')
        } else {
          context.commit('updateConsId', consId)
        }
      }
    },
    updatePharmPassportData: (context, data) => {
      context.commit('updatePharmPassportData', data)
    },
    updateRecommendationsData: (context, data) => {
      context.commit('updateRecommendationsData', data)
    },
    updateResultsData: (context, data) => {
      context.commit('updateResultsData', data)
    },
    updatePharmPassportDataVcId: (context, data) => {
      context.commit('updatePharmPassportDataVcId', data)
    }
  },
  mutations: {
    updateConsId: (state, consId) => {
      state.consId = consId
    },
    updatePharmPassportData: (state, data) => {
      state.pharmPassportData = data
      //console.log(state.PharmPassportData)
    },
    updateRecommendationsData: (state, data) => {
      state.recommendationsData = data
    },
    updateResultsData: (state, data) => {
      state.resultsData = data
    },
    updatePharmPassportDataVcId: (state, data) => {
      state.pharmPassportData[0].vc_id = data
    }
  },
  getters: {
    getConsId: (state) => {
      return state.consId
    },
    getPharmPassportData: (state) => {
      return state.pharmPassportData
    },
    getRecommendationsData: (state) => {
      return state.recommendationsData
    },
    getResultsData: (state) => {
      return state.resultsData
    },
    getPharmPassportDataVcId: (state) => {
      return state.pharmPassportData[0].vc_id
    }
  }
};

const Store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    Layout,
    Auth,
    Consultations,
    Patients
  }
});

export default Store



// WEBPACK FOOTER //
// ./src/Store.js